import { defineMessages } from "@ai360/core/intl";

export const messages = defineMessages({
    addLocation: { id: "setup.orgLevelProducts.addLocation", defaultMessage: "Add Location" },
    city: { id: "setup.orgLevelProducts.city", defaultMessage: "City" },
    name: { id: "setup.orgLevelProducts.name", defaultMessage: "Name" },
    state: { id: "setup.orgLevelProducts.state", defaultMessage: "State" },
    deleteConfirmationTitle: {
        id: "setup.orgLevelProducts.deleteConfirmationTitle",
        defaultMessage: "Delete Confirmation",
    },
    deleteConfirmationMessage: {
        id: "setup.orgLevelProducts.deleteConfirmation",
        defaultMessage: "Are you sure you want to delete the selected Org Level Product?",
    },
});
